import styled from "styled-components";

export const Img = styled.img`
  max-width: 360px;
  margin: 0 auto 40px;
  display: block;
`;

export const HeroSection = styled.section`
  padding: 5rem 0;
  text-align: center;
  position: relative;
`;

export const Headline = styled.h1`
  font-size: 1.5rem;
  margin: 0 auto;
  padding-bottom: 2rem;
  line-height: 1.2;
  max-width: 60rem;
  text-transform: uppercase;

  span {
    color: #38a169;
  }

  @media (min-width: 50rem) {
    font-size: 3rem;
  }
`;

export const Description = styled.div`
  font-size: 1.1rem;
  line-height: 1.4;
  font-weight: 500;
  max-width: 50rem;
  margin: 0 auto;

  @media (min-width: 50rem) {
    font-size: 1.5rem;
  }
`;
